import React from "react";
import BridgeWorks from "../components/BridgeWorks";
import Faq from "../components/Faq";
import BridgeBanner from "./sections/BridgeBanner";
import KeyBenefits from "./sections/KeyBenefits";
import BridgeProcess from "./sections/BridgeProcess";
import { HowItWorks } from "../components/HowItWorks";
import ChooseBridge from "./sections/ChooseBridge";

function Bridge() {
  return (
    <>
      <BridgeBanner />
      <ChooseBridge />
      <HowItWorks />

      <BridgeWorks />
      <Faq />
      <KeyBenefits />
      <BridgeProcess />
    </>
  );
}
export default Bridge;
